import { v4 } from "uuid";

type DisplayMapping<F> = {
  [K in keyof F]?: F[K] extends boolean | undefined
    ? string
    : F[K] extends string | undefined
    ? (value: F[K]) => string
    : Record<string, string>;
};

export function getDisplayFilters<F extends object>(
  filter: F,
  displayAs: DisplayMapping<F>,
  setFilters: (newFilters: Partial<F>) => void
): { id: string; label: string; onDelete: () => void }[] {
  const entries: { id: string; label: string; onDelete: () => void }[] = [];

  for (const id in filter) {
    const value = filter[id];
    const display = displayAs[id];

    if (value == null || display == null) continue;

    const onDelete = () => {
      setFilters({
        ...filter,
        [id]: undefined,
      });
    };

    if (typeof value === "boolean" && typeof display === "string") {
      if (value) {
        entries.push({
          id: v4(),
          label: display,
          onDelete,
        });
      }
    } else if (Array.isArray(value) && typeof display === "object") {
      value.forEach((item) => {
        const label = (display as Record<string, string>)[item as string];
        if (label) {
          entries.push({
            id: v4(),
            label,
            onDelete: () => {
              const newArray = (filter[id] as string[]).filter(
                (v) => v !== item
              );
              setFilters({
                ...filter,
                [id]: newArray.length ? newArray : undefined,
              });
            },
          });
        }
      });
    } else if (typeof display === "function") {
      entries.push({
        id: v4(),
        label: display(value),
        onDelete,
      });
    }
  }

  return entries;
}
